import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import auth from "firebase/auth";
// import { JWT } from "google-auth-library";

const firebaseConfig = {
  apiKey: "AIzaSyCFXWRppzptzZJhU3NIwJE8Ydm-BPRvczU",
  authDomain: "salvesp-81616.firebaseapp.com",
  projectId: "salvesp-81616",
  storageBucket: "salvesp-81616.firebasestorage.app",
  messagingSenderId: "94933698973",
  appId: "1:94933698973:web:3b4b9fc5cdd2e0074b8774",
  measurementId: "G-DCRQ54QK99",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp, "app-proposta-pe");
const storage = getStorage(firebaseApp);

// function generateJWT() {
//   const now = Date.now() / 1000;
//   const key = require("../salvesp-81616-5e817096d8f7.json");
//
//   const jwtPayload = {
//     iss: key.client_email,
//     sub: key.client_email,
//     aud: "https://oauth2.googleapis.com/token",
//     iat: now,
//     exp: now + 3600, // JWT expires in 1 hour
//     scope: ["https://www.googleapis.com/auth/firebase.messaging"].join(" "),
//   };
//
//   return jwt.sign(jwtPayload, key.private_key, { algorithm: "RS256" });
// }

// function getAccessToken() {
//   return new Promise(function (resolve, reject) {
//     const key = require("./salvesp-81616-5e817096d8f7.json");
//     const jwtClient = new JWT({
//       email: key.client_email,
//       key: key.private_key,
//       scopes: ["https://www.googleapis.com/auth/firebase.messaging"],
//     });
//     jwtClient.authorize(function (err, tokens) {
//       if (err) {
//         reject(err);
//         return;
//       }
//       resolve(tokens?.access_token);
//     });
//   });
// }
const sendNotification = async (
  title: string,
  body: string,
  token: string,
  user: auth.User,
) => {
  const notification = {
    message: {
      token: token,
      notification: {
        title: title,
        body: body,
      },
    },
  };

  // const accessToken = getAccessToken();

  try {
    const accessToken =
      "ya29.a0Ad52N395JW1keaWxJoidEkbfnToI-QvSJZW0YuWFHm2Y2PHV1SbFv5rRrXn5yIg41pleVgMZX4GGJi0w7ztF6DaLs_nvQxpWpjj5j6M5iXmQ67YAY_AC63cu7YTLn3GBtMjka9lzU8SZC105qE303IVDXHKuJ6FQDNePaCgYKAX4SARISFQHGX2Mi6u4Hz02Azgz1dstvPvj0eQ0171";
    console.log(JSON.stringify(notification));

    const response = await fetch(
      "https://fcm.googleapis.com/v1/projects/salvesp-81616/messages:send",
      {
        mode: "no-cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(notification),
      },
    );

    if (response.ok) {
      console.log("Notification sent successfully");
    } else {
      console.error("Failed to send notification:", await response.json());
    }
  } catch (error) {
    console.error("Error sending notification");
    console.error(error);
  }
};

export { firebaseApp, db, storage, sendNotification };
